<template lang="pug">
.form-group
  label.control-label Time zone
  AppSelect(
    v-model.number="selected"
    :options="optionsForDisplay"
    :disabled="disabled"
  )
</template>

<script>
export default {
  name: 'AttendanceSchedulesTimeZoneSelect',
  props: {
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    defaultTimeZoneId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.defaultTimeZoneId;
      },
      set(value) {
        this.$emit('updated', value, 'effectiveTimeZone');
      },
    },
    optionsForDisplay() {
      return this.options.map((opt) => ({
        ...opt,
        description: opt.description === 'My timezone' ? 'Specific to each member' : opt.description,
      }));
    },
  },
};
</script>
